// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_3mYj_","slider-btn":"_126js","en-slider":"_2Vh6a","slider-btn-left":"_-0C3L","slider-btn-right":"Z2e5f","image-element":"_1HT-u"};